import { render, staticRenderFns } from "./phase-verb-editor.vue?vue&type=template&id=012771f4&scoped=true&"
import script from "./phase-verb-editor.vue?vue&type=script&lang=ts&"
export * from "./phase-verb-editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012771f4",
  null
  
)

export default component.exports